import { Chat, PinnedChat } from '@src/api/shared/community/chatApiClient';
import { TOOLTIP_DISPLAY_TIME } from '@src/features/shared/community/components/chat/chatList/ChatItemHeader';
import Tooltip from '@src/features/shared/community/components/chat/Tooltip';
import useTooltip from '@src/hooks/useTooltip';
import { getCommunityMemberDetailUrl } from '@src/utils/chat';
import React from 'react';
import { Link } from 'react-router-dom';

type ChatDisplayNameProps = {
  channelCode: string;
  chat: Chat | PinnedChat;
  channelVisibility?: number;
  isLoggedIn?: boolean;
};

const ChatDisplayName: React.FC<ChatDisplayNameProps> = ({
  channelCode,
  chat,
  channelVisibility,
  isLoggedIn = false,
}) => {
  const { showTooltip, displayTooltip } = useTooltip();

  const handleClick = (
    e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLSpanElement>,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    if (!chat.can_click) {
      if (isLoggedIn) {
        return;
      }
      displayTooltip?.(TOOLTIP_DISPLAY_TIME);
      return;
    }
    window.open(
      getCommunityMemberDetailUrl(channelCode, chat, channelVisibility) ?? '',
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <>
      {chat.can_click && (
        <Link
          to={getCommunityMemberDetailUrl(channelCode, chat, channelVisibility) ?? ''}
          className={`min-w-0 ${chat.can_click ? '' : 'pointer-events-none'}`}
          onClick={handleClick}
        >
          <h2 className='truncate text-sm font-medium'>{chat.display_name?.trim() || ''}</h2>
        </Link>
      )}
      {!chat.can_click && (
        <span
          className='min-w-0'
          onClick={handleClick}
        >
          <h2 className='truncate text-sm font-medium'>{chat.display_name?.trim() || ''}</h2>
        </span>
      )}
      {showTooltip && (
        <div className='absolute left-6 top-[47px] z-10 text-[12px]'>
          <Tooltip
            label='表示するには、ログインしてください。'
            weight='500'
          />
        </div>
      )}
    </>
  );
};

export default ChatDisplayName;
